export default "__VITE_ASSET__CyCUY9Zj__";